import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Clock, ArrowRight } from "lucide-react";
import { api } from "../lib/api";

export default function TrialBanner() {
  const nav = useNavigate();
  const [b, setB] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    api.billingMe().then(setB).catch(() => setB(null));
  }, []);

  if (dismissed || !b) return null;
  if (b.subscription_status === "active") return null;
  const days = b.trial_days_left;
  if (days == null || days > 7) return null;

  const isEnded = days <= 0;
  const bg = isEnded ? "#FDECEC" : "#FFF0D2";
  const bd = isEnded ? "#F5C7C7" : "#FFD166";
  const fg = isEnded ? "#7C2A21" : "#7A4C0B";

  return (
    <div
      data-testid="trial-banner"
      className="border-b px-4 lg:px-8 py-2 text-[12.5px] flex items-center justify-between gap-3"
      style={{ background: bg, borderColor: bd, color: fg }}
    >
      <div className="flex items-center gap-2 min-w-0">
        <Clock className="w-3.5 h-3.5 shrink-0" />
        <span className="truncate">
          {isEnded
            ? "Votre essai est terminé — activez votre abonnement pour continuer."
            : `Il vous reste ${days} jour${days > 1 ? "s" : ""} d'essai gratuit.`}
        </span>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        <button
          data-testid="trial-banner-cta"
          onClick={() => nav("/parametres?checkout=1")}
          className="h-7 px-3 rounded-md text-[#111111] text-[12px] font-semibold inline-flex items-center gap-1"
          style={{ background: "#FF9F1C" }}
        >
          S'abonner <ArrowRight className="w-3 h-3" />
        </button>
        <button
          data-testid="trial-banner-close"
          onClick={() => setDismissed(true)}
          className="h-7 px-2 text-[13px] hover:underline"
          aria-label="Masquer"
        >
          ×
        </button>
      </div>
    </div>
  );
}
